// ⚠️⚠️⚠️⚠️ DO NOT EDIT ⚠️⚠️⚠️⚠️
// This file was automatically generated, run pnpm gen:gql to update it
/* eslint-disable */

import type * as Types from '../../../../schema/public';

import { gql } from '@apollo/client';
import { TagsFragmentDoc } from '../../../../shared/graphql/tags/TagsQuery.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ToggleMbtcMutationVariables = Types.Exact<{
  mBTC?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  uBTC?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type ToggleMbtcMutation = { __typename?: 'Mutation', featuresToggleMbtc?: { __typename?: 'FeaturesToggleMbtcPayload', isMbtcEnabled?: boolean, features?: { __typename: 'Features', id: string, marketingEnabled?: boolean, marketingEnabledSMS?: boolean, marketingEnabledCall?: boolean, marketingEnabledDirectMail?: boolean, videoNotificationsDisabled?: boolean, uBTC?: boolean, mBTC?: boolean, VIP?: boolean, Insider?: boolean, isAmsUser?: boolean }, errors?: Array<{ __typename?: 'FeaturesError', message?: string, code?: number, params?: Array<{ __typename?: 'FeaturesErrorParam', name?: string, value?: string }> }> } };


export const ToggleMbtcMutationDocument = /*#__PURE__*/ gql`
    mutation ToggleMbtcMutation($mBTC: Boolean, $uBTC: Boolean) {
  featuresToggleMbtc(input: {mBTC: $mBTC, uBTC: $uBTC}) {
    isMbtcEnabled
    features {
      id
      ...TagsFragment
    }
    errors {
      message
      code
      params {
        name
        value
      }
    }
  }
}
    ${TagsFragmentDoc}`;
export type ToggleMbtcMutationMutationFn = Apollo.MutationFunction<ToggleMbtcMutation, ToggleMbtcMutationVariables>;
export function useToggleMbtcMutation(baseOptions?: Apollo.MutationHookOptions<ToggleMbtcMutation, ToggleMbtcMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleMbtcMutation, ToggleMbtcMutationVariables>(ToggleMbtcMutationDocument, options);
      }
export type ToggleMbtcMutationHookResult = ReturnType<typeof useToggleMbtcMutation>;
export type ToggleMbtcMutationMutationResult = Apollo.MutationResult<ToggleMbtcMutation>;
export type ToggleMbtcMutationMutationOptions = Apollo.BaseMutationOptions<ToggleMbtcMutation, ToggleMbtcMutationVariables>;